import React, { useMemo } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { MDBDataTableV5 } from "mdbreact";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";

const INSTITUTE_TABLE_COLUMNS = [
  {
    label: "#",
    field: "index",
    sort: "asc",
    width: 50,
  },
  {
    label: "Nombre",
    field: "nombre",
    sort: "asc",
  },
  {
    label: "Fecha fin de subscripción",
    field: "fechaFinSubInstituto",
    sort: "asc",
  },
  {
    label: "Vencido",
    field: "vencido",
    sort: "asc",
  },
  {
    label: "Correo",
    field: "correo",
    sort: "asc",
  },
  {
    label: "País",
    field: "pais",
    sort: "asc",
  },
  {
    label: "Dirección",
    field: "direccion",
    sort: "asc",
  },
  {
    label: "Tipo de ingreso",
    field: "tipoIngreso",
    sort: "asc",
  },
  {
    label: "Tipo de servicio",
    field: "tipoServicio",
    sort: "asc",
  },
  {
    label: "Super instituto",
    field: "superInstituto",
    sort: "asc",
  },
  {
    label: "Estado subscripción",
    field: "estadoSubscripcion",
    sort: "asc",
  },
  {
    label: "Estado activación",
    field: "estadoActivacion",
    sort: "asc",
  },
  {
    label: "Ingreso App",
    field: "ingresoApp",
    sort: "asc",
  },
  {
    label: "Permite individuales",
    field: "permitirIndividuales",
    sort: "asc",
  },
  {
    label: "Flujo alterno",
    field: "flujoAlterno",
    sort: "asc",
  },
  {
    label: "Datos en pide tu demo",
    field: "datosEnPideTuDemo",
    sort: "asc",
  },
  {
    label: "Lecturas diarias",
    field: "lecturasDiarias",
    sort: "asc",
  },
  {
    label: "Concurrencias",
    field: "concurrencias",
    sort: "asc",
  },
  {
    label: "Link acceso",
    field: "linkAcceso",
    sort: "disabled",
  },
  {
    label: "Link web",
    field: "linkAccesoWeb",
    sort: "disabled",
  },
  {
    label: "Link tutorial",
    field: "linkTutorial",
    sort: "disabled",
  },
];

const formatBooleanDisplay = (value) => (value === 1 || value === "1" ? "Sí" : "No");

const createLinkCell = (url) =>
  url ? (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {url}
    </a>
  ) : (
    "N/A"
  );

const DetalleInstitutosCuentasPersonales = () => {
  const history = useHistory();
  const location = useLocation();
  const institutes = location.state?.institutes ?? [];
  const clientLabel =
    location.state?.clientLabel ?? location.state?.username ?? location.state?.email ?? null;

  const instituteRows = useMemo(
    () =>
      institutes.map((inst, index) => ({
        index: index + 1,
        nombre: inst.nombre || "Sin nombre",
        fechaFinSubInstituto: inst.fechaFinSubInstituto || "Sin dato",
        vencido: inst.fechaFinSubInstituto < new Date() ? "Sí" : "No",
        telefono: inst.telefono || "Sin dato",
        correo: inst.correo || "Sin dato",
        pais: inst.pais || "Sin dato",
        direccion: inst.direccion || "Sin dato",
        tipoIngreso: inst.tipoIngreso || "Sin dato",
        tipoServicio: inst.tipoServicio || "Sin dato",
        superInstituto: inst.superInstituto || "Sin dato",
        estadoSubscripcion: formatBooleanDisplay(inst.estadoSubscripcion),
        estadoActivacion: formatBooleanDisplay(inst.estadoActivacion),
        ingresoApp: formatBooleanDisplay(inst.ingresoApp),
        permitirIndividuales: formatBooleanDisplay(inst.permitirIndividuales),
        flujoAlterno: formatBooleanDisplay(inst.flujoAlterno),
        datosEnPideTuDemo: formatBooleanDisplay(inst.datosEnPideTuDemo),
        lecturasDiarias: inst.lecturasDiarias ?? "0",
        concurrencias: inst.concurrencias ?? "0",
        linkAcceso: createLinkCell(inst.linkAcceso),
        linkAccesoWeb: createLinkCell(inst.linkAccesoWeb),
        linkTutorial: createLinkCell(inst.linkTutorial),
      })),
    [institutes]
  );

  const handleBack = () => {
    history.push("/consultas/lista-cuentas-personales");
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <MenuBookIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Institutos por cliente</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="d-flex justify-content-end mb-3">
            <CustomGreenButton onClick={handleBack}>
              <ArrowBackIcon fontSize="small" className="mr-2" />
              Regresar a usuarios
            </CustomGreenButton>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <MenuBookIcon />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                {clientLabel
                  ? `Institutos asociados a ${clientLabel}`
                  : "Sin cliente seleccionado"}
              </div>
            </div>
            <div className="admin-muted-text-small mt-1 mb-3">
              {clientLabel
                ? "Detalle completo de los institutos asignados a este usuario."
                : "Debes regresar a la lista de usuarios y seleccionar el botón Ver para cargar información."}
            </div>
            {instituteRows.length > 0 ? (
              <MDBDataTableV5
                small
                responsive
                striped
                bordered
                searchTop
                searchBottom={false}
                barReverse
                pagingTop
                data={{
                  columns: INSTITUTE_TABLE_COLUMNS,
                  rows: instituteRows,
                }}
                noBottomColumns
                order={["index", "asc"]}
                entriesOptions={[5, 10, 20, 50]}
                entriesLabel="Numero de filas"
                searchLabel="Buscar"
                paginationLabel={["Anterior", "Siguiente"]}
                infoLabel={["Mostrando filas", "a", "de", "filas"]}
                fullPagination
              />
            ) : (
              <div className="admin-muted-text-small">
                No se encontraron institutos para este usuario. Utiliza el botón “Regresar a usuarios”
                para seleccionar otro registro.
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DetalleInstitutosCuentasPersonales;

